import React from 'react';
import './MonthItem.scss';
import {getMonthName} from "../../../../tools/formatter";
import {connect} from "react-redux";
import Counters from "../../Counters/Counters";
import {Card, CardActionArea, CardActions, CardContent, CardMedia} from "@mui/material";
import Typography from "@mui/material/Typography";
import config from "../../../../api/config";
import {cardMediaStyles} from "../../../../styles/styles";

function MonthItem(props) {
	const {item, monthNumber} = props;
	return <Card sx={{ maxWidth: 800 }}>
		<CardActionArea>
			<CardContent>
				<Typography className={monthNumber === parseInt(props.currentNavigationMonth) ? " active" : ""} gutterBottom variant="h5" component="div">
					{getMonthName(window.navigator.language, monthNumber)}
				</Typography>
			</CardContent>
			<CardMedia
				component="img"
				image={props.label != null ? (props.label !== false ? config.thumbnailLambdaUrl + '?key=/' + props.label.userimage + (props.label.transform ? '&transform=' + props.label.transform : '') : "/noimage.jpg") : '/loading.gif'}
				alt={props.label?.userimage || 'No image'}
				sx={cardMediaStyles}
			/>
			<CardActions sx={{ pt: 2, pr: 2.5, pb: 1, pl: 1, minHeight: 64 }}>
				<Counters item={item} />
			</CardActions>
		</CardActionArea>
	</Card>
}

const mapStateToProps = state => {
	return {
		currentNavigationMonth: state.eventsData.currentNavigationMonth
	};
};

export default connect(mapStateToProps)(MonthItem);
